[
    "Account closed",
    "Auto Dispose",
    "Call back",
    "Call drop",
    "CashBack Offer",
    "CD",
    "Client cancellation",
    "Customer deliberately misleading",
    "Customer disputed default amount",
    "Customer disputed last EMI of payment",
    "Customer Expired",
    "Customer indicated amount to be paid",
    "Customer indicated possibility of pay back",
    "DND",
    "Escalation",
    "Foreclosure Offer",
    "Future prospects",
    "Inbound",
    "Language barrier",
    "Leave Message",
    "LS",
    "Need FollowUp",
    "NOC Request",
    "No contact details",
    "Not interested",
    "Not Reachable",
    "NRTP",
    "Paid",
    "Partial Paid",
    "Profile Update",
    "PTP",
    "Ringing No Response",
    "Settlement Offer",
    "Special",
    "Switch off",
    "Waiver Request",
    "WN",
    "Awaiting credit report",
    "Budgeting done",
    "Care introduction",
    "Enrolled client",
    "New client",
    "Payment reminder",
    "Program explained",
    "Current",
    "Debt amount not qualified",
    "Need loan",
    "No Outstandings",
    "Not looking for settlement",
    "Not answering",
    "Number not in service",
    "Switch off"
    ]
    